import { dateRangeSchema, levelSelectSchema } from '@retail/calculus/components';
import { CalculusTFunction } from '@retail/calculus/i18n';
import { PriceSuggestionType } from '@retail/products/types';
import * as yup from 'yup';

export const followPriceSuggestionSchema = (t: CalculusTFunction) =>
  levelSelectSchema(t)
    .concat(dateRangeSchema(t))
    .concat(
      yup.object({
        priceSuggestionPriority: yup
          .array<PriceSuggestionType[]>(yup.string())
          .default([])
          .min(1)
          .required(),
      })
    );

export type FollowPriceSuggestionSchema = yup.InferType<
  ReturnType<typeof followPriceSuggestionSchema>
>;
